import types from "../actionTypes";

export default (
  state = {
    managerApplicationCount: undefined,
  },
  action
) => {
  switch (action.type) {
    case types.SET_MANAGER_TOTAL_APP_COUNT:
      return Object.assign({}, state, {
        managerApplicationCount: action.managerApplicationCount,
      });
    default:
      return state;
  }
};
